import { render, staticRenderFns } from "./contacto.vue?vue&type=template&id=486c9dbb&"
import script from "./contacto.component.ts?vue&type=script&lang=ts&"
export * from "./contacto.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports